import { createContext, useContext } from 'react';

import type { AccountStatusState } from '@src/models/interfaces/accountStatus.interface';
import { DEFAULT_ACCOUNT_STATUS } from '@src/models/mappers/AccountStatusMapper';

/**
 * Outside the provider (public screens, tests) the account is writable: the read-only gate
 * only applies where an organization's status is actually being listened to.
 */
export const DEFAULT_ACCOUNT_STATUS_STATE: AccountStatusState = {
  snapshot: DEFAULT_ACCOUNT_STATUS,
  loaded: false,
  writable: true,
};

export const AccountStatusContext = createContext<AccountStatusState>(DEFAULT_ACCOUNT_STATUS_STATE);

export const useAccountStatus = (): AccountStatusState => useContext(AccountStatusContext);

/** False when the active organization's account is read_only, suspended or cancelled. */
export const useAccountWritable = (): boolean => useContext(AccountStatusContext).writable;
